import { useState, useEffect } from 'react';
import type { Editor as TiptapEditor } from '@tiptap/core';
import styled from 'styled-components';

import { Text, useI18n, defaultThemeProp } from '@pega/cosmos-react-core';

const StyledText = styled(Text)`
  text-align: right;
`;

StyledText.defaultProps = defaultThemeProp;

interface WordCountProps {
  editor: TiptapEditor;
  'data-testid'?: string;
}

const WordCount = ({ editor, 'data-testid': dataTestId }: WordCountProps) => {
  const t = useI18n();
  const [wordCount, setWordCount] = useState(0);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    const updateCounts = () => {
      const text = editor.getText();
      const trimmedText = text.trim();
      const words = trimmedText ? trimmedText.split(/\s+/).length : 0;
      const chars = text.length;
      setWordCount(words);
      setCharCount(chars);
    };

    updateCounts();
    editor.on('update', updateCounts);

    return () => {
      editor.off('update', updateCounts);
    };
  }, [editor]);

  return (
    <StyledText variant='secondary' data-testid={dataTestId}>
      {t('rte_word_count', [wordCount], { count: wordCount })},{' '}
      {t('rte_character_count', [charCount], { count: charCount })}
    </StyledText>
  );
};

export default WordCount;
